export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5051.4640cc64.jpg";